import React from 'react';
import { Link } from 'react-router-dom';
import { Phone, Mail, MapPin, Clock, Facebook, Twitter, Instagram } from 'lucide-react';
import { practiceInfo } from '../data/siteData';
import './Footer.css';

function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="main-footer">
      <div className="footer-top">
        <div className="container">
          <div className="footer-grid">
            <div className="footer-section footer-about">
              <div className="footer-logo">
                <div className="logo-icon"><span>P3</span></div>
                <div className="logo-text">
                  <h3>P3 Dental</h3>
                  <p>Northeast Philadelphia</p>
                </div>
              </div>
              <p className="footer-description">
                The doctors of P3 Dental are gentle, caring dentists who use only the most advanced 
                materials & procedures available.
              </p>
              <p className="eagles-badge">🏈 Official Dentist of the Philadelphia Eagles!</p>
            </div>

            <div className="footer-section footer-hours">
              <h4><Clock size={18} /> Office Hours</h4>
              <ul className="hours-list">
                {practiceInfo.hours.map((schedule, index) => (
                  <li key={index}>
                    <span className="day">{schedule.day}</span>
                    <span className="time">{schedule.close ? `${schedule.open} - ${schedule.close}` : schedule.open}</span>
                  </li>
                ))}
              </ul>
            </div>

            <div className="footer-section footer-contact">
              <h4>Contact Us</h4>
              <ul className="contact-list">
                <li><MapPin size={18} /><div><span>{practiceInfo.address.street}</span><span>{practiceInfo.address.city}, {practiceInfo.address.state} {practiceInfo.address.zip}</span></div></li>
                <li><Phone size={18} /><a href={`tel:${practiceInfo.phone.replace(/[^0-9]/g, '')}`}>{practiceInfo.phone}</a></li>
                <li><Mail size={18} /><a href={`mailto:${practiceInfo.email}`}>{practiceInfo.email}</a></li>
              </ul>
              <div className="social-links">
                <a href="https://facebook.com" target="_blank" rel="noopener noreferrer" aria-label="Facebook"><Facebook size={20} /></a>
                <a href="https://twitter.com" target="_blank" rel="noopener noreferrer" aria-label="Twitter"><Twitter size={20} /></a>
                <a href="https://instagram.com" target="_blank" rel="noopener noreferrer" aria-label="Instagram"><Instagram size={20} /></a>
              </div>
            </div>

            <div className="footer-section footer-links">
              <h4>Quick Links</h4>
              <ul>
                <li><Link to="/">Welcome</Link></li>
                <li><Link to="/our-practice">Our Practice</Link></li>
                <li><Link to="/cosmetic-dentistry">Cosmetic Dentistry</Link></li>
                <li><Link to="/procedures">Procedures</Link></li>
                <li><Link to="/appointment-request">Appointment Request</Link></li>
                <li><Link to="/contact-us">Contact Us</Link></li>
              </ul>
            </div>
          </div>
        </div>
      </div>

      <div className="footer-bottom">
        <div className="container">
          <div className="footer-bottom-content">
            <p>&copy; {currentYear} P3 Dental of Northeast Philadelphia. All rights reserved.</p>
            <div className="footer-bottom-links">
              <Link to="/privacy-policy">Privacy Policy</Link>
              <span>|</span>
              <Link to="/terms-and-conditions">Terms and Conditions</Link>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
